exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-delete-office{position:absolute;right:16px;top:44px;padding:4px;z-index:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44ee1599","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/DocumentaryProcedure/Resources/assets/js/views/files/Offices.vue
// module id = 6PE0
// module chunks = 0